module.exports = __webpack_public_path__ + "static/img/bg.936e256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 2